import * as actions from "./actions";
import * as types from "./actionTypes";
import constants from "../../configs/constants";

const socketMiddleware = () => {
  let socket = null;

  const onOpen = store => event => {
    store.dispatch(actions.wsConnected(event.target.url));
  };

  const onClose = store => () => {
    store.dispatch(actions.wsDisconnected());
  };

  const onMessage = store => event => {
    const payload = JSON.parse(event.data);
    // console.log("received payload:", payload);
    if (payload.message_type) {
      store.dispatch(actions.wsMessage(payload));
    }
  };

  return store => next => action => {
    switch (action.type) {
      case types.WS_CONNECT:
        if (socket !== null) {
          socket.close();
        }

        // connect to the remote host
        socket = new WebSocket(action.host);

        // websocket handlers
        socket.onmessage = onMessage(store);
        socket.onclose = onClose(store);
        socket.onopen = onOpen(store);

        break;
      case types.WS_DISCONNECT:
        if (socket !== null) {
          socket.close();
        }
        socket = null;
        break;
      case types.WS_SEND:
        socket.send(JSON.stringify(action.payload));
        break;
      default:
        return next(action);
    }
  };
};

export default socketMiddleware();
